import { render } from "./LazyImg.vue?vue&type=template&id=c00c05a6&scoped=true"
import script from "./LazyImg.vue?vue&type=script&lang=js"
export * from "./LazyImg.vue?vue&type=script&lang=js"

import "./LazyImg.vue?vue&type=style&index=0&id=c00c05a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c00c05a6"]])

export default __exports__